import api from '@/api'
import {
  SET_MINIPROGRAM_AD_LIST,
  SET_MINIPROGRAM_AD_LIST_PAGE_SIZE,
  SET_MINIPROGRAM_AD_LIST_TOTAL,
  SET_MINIPROGRAM_AD_PAGE_COUNT,
} from './mutation-types'
const state = {
  pageSize: 20,
  pageCount: 0,
  total: 0,
  miniProgramAdList: [],
}
const mutations = {
  [SET_MINIPROGRAM_AD_LIST](state, payload) {
    state.miniProgramAdList = payload
  },
  [SET_MINIPROGRAM_AD_PAGE_COUNT](state, payload) {
    state.pageCount = payload
  },
  [SET_MINIPROGRAM_AD_LIST_PAGE_SIZE](state, payload) {
    state.pageSize = payload
  },
  [SET_MINIPROGRAM_AD_LIST_TOTAL](state, payload) {
    state.total = payload
  },
}
const actions = {
  async getMiniProgramAdList({ state, commit }, payload) {
    let params = {
      pageSize: payload.pageSize,
      pageNum: payload.pageNum,
      advertisingTitle: payload.advertisingTitle,
      startTime: payload.startTime,
      endTime: payload.endTime,
    }
    try {
      const {
        data: { items, pageCount, total },
      } = await api.deployApi.getMiniProgramAdvertiseList(params)
      commit(SET_MINIPROGRAM_AD_LIST, items)
      commit(SET_MINIPROGRAM_AD_PAGE_COUNT, pageCount)
      commit(SET_MINIPROGRAM_AD_LIST_TOTAL, total)
    } catch (error) {
      commit(SET_MINIPROGRAM_AD_LIST, [])
      commit(SET_MINIPROGRAM_AD_PAGE_COUNT, 0)
    }
  },
  refreshMiniProgramAdList({ dispatch }) {
    dispatch('getMiniProgramAdList', { pageNum: 1, pageSize: state.pageSize })
  },
  updatePageSize({ commit }, payload) {
    commit(SET_MINIPROGRAM_AD_LIST_PAGE_SIZE, payload)
  },
  // 新增
  async addMiniProgramAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.addMiniProgramAdvertise(payload)
    dispatch('refreshMiniProgramAdList')
    return result
  },
  // 编辑
  async editMiniProgramAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.editMiniProgramAdvertise(payload)
    dispatch('refreshMiniProgramAdList')
    return result
  },
  // 删除
  async deleteMiniProgramAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.deleteMiniProgramAdvertise(payload)
    dispatch('refreshMiniProgramAdList')
    return result
  },
  async exportMiniProgramAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.exportMiniProgramAdvertise(payload)
    dispatch('refreshMiniProgramAdList')
    return result
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
